module.exports = __webpack_public_path__ + "img/red-delete-icon.0e740f67.svg";